// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useDisclosure, IconButton } from "@chakra-ui/react";

import { Alert } from "@unifize/sarah";

import * as styles from "../styles";
import Icon from "src/icons";
import * as colors from "src/styles/constants/colors";

type Props = {
  series?: boolean,
  title: string,
  handleDelete: Function,
};

const DeleteModal = ({ series, title, handleDelete }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onDelete = () => {
    handleDelete();
    onClose();
  };

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onOpen();
        }}
        sx={{ ...styles.IconButton, mt: series ? "1rem" : 0 }}
        icon={<Icon type="deleteTrash" color={colors.inkLightest} />}
      />
      <Alert
        isOpen={isOpen}
        onClose={onClose}
        prompt={`${i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_DELET2)} ${title} ${i18n.t(k._20)} ${series ? i18n.t(k.SERIES) : i18n.t(k.CHART)}?`}
        confirmVariant="destructive"
        handleConfirm={onDelete}
      />
    </>
  );
};

export default DeleteModal;
